import React from 'react'

const PencilIcon = () => {
	return (
		<svg width={22} height={22} viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M7.886 19.141l-3.395.642a1.946 1.946 0 01-2.274-2.274l.642-3.395c.073-.384.26-.738.536-1.015L14.8 1.696a1.946 1.946 0 012.247-.365l.749.375a5.59 5.59 0 012.5 2.5l.374.748c.375.75.228 1.655-.365 2.247L8.901 18.605c-.277.276-.63.463-1.015.536zM4.129 17.87l3.395-.643L18.928 5.824l-.375-.75a3.643 3.643 0 00-1.629-1.629l-.749-.374L4.772 14.475l-.643 3.394z'
				fill='currentColor'
			/>
			<path
				d='M17.703 8.426l-4.129-4.13-1.376 1.377 4.129 4.129 1.376-1.376zM4.628 14.62l-2.065 2.064 2.753 2.753 2.065-2.065-2.753-2.753z'
				fill='currentColor'
			/>
		</svg>
	)
}

export default PencilIcon
